module.exports = __webpack_public_path__ + "static/media/icon_9.03d3abec.svg";